import styled from '@emotion/styled';
import { List } from '@mui/material';

export const ScrollingList = styled(List)`
  overflow-y: scroll;
`;
